import { FC } from 'react';
import { Avatar } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { fromISOtoFormat } from 'src/common/utils/dataFormat';
import { IVanHost } from 'src/store/reducers/host/types';
import Icons from 'src/common/icons';
import './styles.scss';
import './media.scss';

interface IProps {
  host: IVanHost;
}

const MainHostInfo: FC<IProps> = ({ host }) => {
  const { photo, first_name, created_at, state, city } = host;

  return (
    <div className='main-host'>
      <Avatar alt='user photo' src={photo ?? '/broken-image.jpg'} className='main-host__photo' />
      <div className='main-host__name'>
        <h5>{first_name}</h5>
        <span>
          {state} - {city}
        </span>
      </div>
      <div className='main-host__rating'>
        <span>4.9</span>
        <StarIcon />
      </div>
      <span className='main-host__joined'>Joined {fromISOtoFormat(created_at, 'MMM yyyy')}</span>
      <div className='main-host__verify'>
        <Icons.Verified />
        <span>Identity verified</span>
      </div>
    </div>
  );
};
export default MainHostInfo;
